// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__6Plps","title":"style_title__BIB_k","list":"style_list__i21pa","btn":"style_btn__7UUuJ","item":"style_item__g9XRQ"};